import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { UseMutationOptions } from 'react-query'
import {
  updateAttackEventsTags,
  UpdateAttackEventsTagsArgs
} from './requests/update-attack-events-tags'
import { BaseApiResponse } from '../../../api/shared'
import { HTTPError } from '../../../api/fetch/decorate-fetch'

export interface UseUpdateAttackEventsTagsResult {
  mutate: (
    variables: UpdateAttackEventsTagsArgs,
    options?: UseMutationOptions<
      BaseApiResponse,
      Error,
      UpdateAttackEventsTagsArgs
    >
  ) => void
  isSuccess: boolean
  isError: boolean
  error: Error | null
  data: BaseApiResponse | undefined
}

export function useUpdateAttackEventsTags(
  options?: UseMutationOptions<
    BaseApiResponse,
    Error,
    UpdateAttackEventsTagsArgs
  >
): UseUpdateAttackEventsTagsResult {
  const { mutate, isSuccess, data, error, isError } = useContrastMutation<
    BaseApiResponse,
    HTTPError,
    UpdateAttackEventsTagsArgs
  >(updateAttackEventsTags, options)

  return { mutate, isSuccess, data, error, isError }
}
